import * as types from "./actionTypes";

export const setResources = (resourceType, resources) => ({
  type: types.SET_RESOURCES,
  payload: {resourceType, resources}
});

export const addResource = (resourceType, resource) => ({
  type: types.ADD_RESOURCE,
  payload: {resourceType, resource}
});

export const changeResource = (resourceType, resource) => ({
  type: types.CHANGE_RESOURCE,
  payload: {resourceType, resource}
});

export const deleteResource = (resourceType, id) => ({
  type: types.DELETE_RESOURCE,
  payload: {resourceType, id}
});

export const deleteResourceAttachedTo = (resourceType, attachedTo) => ({
  type: types.DELETE_RESOURCE_ATTACHED_TO,
  payload: {resourceType, attachedTo}
});

export const deleteAllResources = () => ({
  type: types.DELETE_ALL_RESOURCES,
  payload: {}
});

export const setSelectedFeature = (selectedFeature) => ({
  type: types.SET_SELECTED_FEATURE,
  payload: {selectedFeature}
});

export const setSelectedPartIds = (selectedPartIds) => ({
  type: types.SET_SELECTED_PART_IDS,
  payload: {selectedPartIds}
});

export const setSelectedHandle = (selectedHandle) => ({
  type: types.SET_SELECTED_HANDLE,
  payload: {selectedHandle}
});

export const setSelectedHinge = (selectedHinge) => ({
  type: types.SET_SELECTED_HINGE,
  payload: {selectedHinge}
});
